import { ThemedExpandIcon, ThemedCompressIcon } from "assets/CXFIcons/Arrows";
import { useTheme } from "@mui/material/styles";

export const EditorExpansion = ({ isExpanded, handleExpansion }) => {
  const { isDarkTheme } = useTheme();
  const fillColor = isDarkTheme ? "#ffffffff" : "#000";

  return (
    <button
      type="button"
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        height: "1rem",
        width: "1rem",
        inset: "auto 1rem 1rem auto",
        position: "absolute",
        marginRight: "0.8rem"
      }}
      onClick={handleExpansion}
    >
      {isExpanded ? (
        <ThemedCompressIcon fillColor={fillColor} width="26px" height="26px" />
      ) : (
        <ThemedExpandIcon fillColor={fillColor} width="26px" height="26px" />
      )}
    </button>
  );
};
